import useSWR from "swr";
import { endpointsSpeckle } from "../actions/endpointsSpeckle";
import { fetcher } from "lib/actions/fetcher";
import { speckleCreateModel } from "../actions/speckleCreateModel";
import { SpeckleModelModel } from "../../SpeckleImportWizard/types/SpeckleModelModel";

export function useSpeckleModels(
  speckleConnectedAccountId: number,
  speckleProjectId: string,
) {
  const {
    data: models,
    error,
    isLoading,
    mutate,
  } = useSWR<SpeckleModelModel[]>(
    speckleConnectedAccountId &&
      speckleProjectId &&
      endpointsSpeckle.models(speckleConnectedAccountId, speckleProjectId),
    fetcher,
  );

  async function create(model: Omit<SpeckleModelModel, "id">) {
    if (!speckleConnectedAccountId || !speckleProjectId) return;
    const createModelTask = speckleCreateModel(
      speckleConnectedAccountId,
      speckleProjectId,
      model,
    );

    await mutate(
      async (models) => {
        const model = await createModelTask;
        return models ? [...models, model] : [model];
      },
      {
        revalidate: false,
      },
    );
    return await createModelTask;
  }

  async function refresh() {
    await mutate();
  }

  return {
    models,
    hasError: !!error,
    isLoading,
    create,
    refresh,
  };
}
